import { connect } from 'react-redux';

import paymentGatewaysActionCreators from '_store/_actions/companyPaymentGateways';

import Gateways from './CompanyGateways';

const mapStateToProps = state => ({
  activeCompany: state.company.activeCompany,
  availablePaymentGateways: state.companyPaymentGateways.availablePaymentGateways,
  paymentGateways: state.companyPaymentGateways.paymentGateways,
});

const mapDispatchToProps = {
  onCreatePaymentGateway: paymentGatewaysActionCreators.createPaymentGateway,
  onUpdatePaymentGateway: paymentGatewaysActionCreators.updatePaymentGateway,
  onDeletePaymentGateway: paymentGatewaysActionCreators.deletePaymentGateway,

  onFetchPaymentGateways: paymentGatewaysActionCreators.fetchPaymentGateways,
  onFetchAvailablePaymentGateways:
    paymentGatewaysActionCreators.fetchAvailablePaymentGateways,
};

export default connect(mapStateToProps, mapDispatchToProps)(Gateways);
